<template>
    <b-card no-body>
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">
                <b-icon icon="search" aria-hidden="true"></b-icon>
                Filtro de busqueda
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
                <b-card-text>
                    <b-row>
                        <b-col cols="12" md="4">
                            <label for="companyName">Empresa</label>
                            <b-form-input id="companyName" v-model="filter.companyName" @keydown.enter.prevent="$emit('get-users-list')" placeholder="Nombre Empresa"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="name">Nombre</label>
                            <b-form-input id="name" v-model="filter.name" @keydown.enter.prevent="$emit('get-users-list')" placeholder="Nombre"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="email">Correo</label>
                            <b-form-input id="email" v-model="filter.email" @keydown.enter.prevent="$emit('get-users-list')" placeholder="Correo"></b-form-input>
                        </b-col>

                        <b-col cols="12" md="4">
                            <label for="nit">NIT</label>
                            <b-form-input id="nit" v-model="filter.nit" @keydown.enter.prevent="$emit('get-users-list')" placeholder="NIT"></b-form-input>
                        </b-col>

                        <b-col cols="12" md="4">
                            <label for="status">Estado</label>
                            <b-form-select id="status" v-model="filter.status" :options="statusOptions">
                                <template #first>
                                    <b-form-select-option :value="null">Todos</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" md="12">
                            <div class="mt-2">
                                <b-button variant="info" @click.prevent="$emit('get-users-list')" class="mr-1">
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                    Buscar
                                </b-button>
                                <b-button variant="warning" @click.prevent="$emit('clear-filter-form')" class="mx-1 text-white">
                                    <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                    Limpiar
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
export default {
    name: "FilterForm",
    props: {
        filter: {
            type: Object
        }
    },
    data() {
        return {
            statusOptions: [
                { value: false, text: 'Inactivo'  },
                { value: true, text: 'Activo'    },
            ]
        }
    }
}
</script>